import {
  AppstoreOutlined,
  MenuOutlined,
  SearchOutlined
} from '@ant-design/icons';
import {
  Input, Button, Select
} from 'antd';
import debounce from 'lodash/debounce';
import dayjs from 'dayjs';
import classNames from 'classnames';
import { LiveIcon } from 'src/icons';
import { useRouter } from 'next/router';
import style from './search-bar.module.scss';

const { Search } = Input;

type TimeType = 'month' | 'quarter' | 'half';

interface IProps {
  tab: string;
}

export default function FilterContentsBar({
  tab
}: IProps) {
  const router = useRouter();

  const handleFilter = (values: Record<string, any>) => {
    router.push({
      pathname: router.pathname,
      query: {
        ...router.query,
        ...values
      }
    }, undefined, { shallow: true });
  };

  const onSearch = debounce((e) => {
    const value = e.target?.value || '';
    handleFilter({ q: value });
  }, 500);

  const selectDate = (type: TimeType) => {
    const today = dayjs();
    let fromDate = '' as any;

    switch (type) {
      case 'month':
        fromDate = today.subtract(1, 'month').startOf('day');
        break;
      case 'quarter':
        fromDate = today.subtract(3, 'months').startOf('day');
        break;
      case 'half':
        fromDate = today.subtract(6, 'months').startOf('day');
        break;
      default:
        break;
    }
    router.push({
      pathname: router.pathname,
      query: {
        ...router.query,
        timeRange: type,
        fromDate: (fromDate && fromDate.format('YYYY-MM-DD')) || '',
        toDate: (fromDate && today.format('YYYY-MM-DD')) || ''
      }
    }, undefined, { shallow: true });
  };

  const onFilterLive = () => {
    router.push({
      pathname: router.pathname,
      query: {
        ...router.query,
        type: !router?.query?.type ? 'scheduled-streaming' : ''
      }
    }, undefined, { shallow: true }); // force reload feeds
  };

  return (
    <div className={style['filter-content']}>
      <Search
        prefix={<SearchOutlined />}
        suffix={null}
        placeholder="Enter keyword here..."
        onChange={onSearch}
        allowClear
        enterButton={null}
      />
      <div className={style['grid-btns']}>
        <Select onChange={selectDate} defaultValue={router?.query?.timeRange || ''} style={{ minWidth: 134 }}>
          <Select.Option value="">All time</Select.Option>
          <Select.Option value="month">Last 1 month</Select.Option>
          <Select.Option value="quarter">Last 3 months</Select.Option>
          <Select.Option value="half">Last 6 months</Select.Option>
        </Select>
        {tab === 'post' && (
        <Button className={classNames({ active: router?.query?.type === 'scheduled-streaming' })} onClick={() => onFilterLive()}>
          <LiveIcon />
        </Button>
        )}
        {tab === 'post' && (
          <Button
            aria-hidden
            className={classNames({ active: router?.query?.isGrid === 'true' })}
            onClick={() => handleFilter({ isGrid: true })}
          >
            <AppstoreOutlined />
          </Button>
        )}
        {tab === 'post' && (
          <Button
            aria-hidden
            className={classNames({ active: !router?.query?.isGrid || router?.query?.isGrid === 'false' })}
            onClick={() => handleFilter({ isGrid: false })}
          >
            <MenuOutlined />
          </Button>
        )}
      </div>
    </div>
  );
}
